import { render, staticRenderFns } from "./SetSearch.vue?vue&type=template&id=720f446c&scoped=true&"
import script from "./SetSearch.vue?vue&type=script&lang=js&"
export * from "./SetSearch.vue?vue&type=script&lang=js&"
import style0 from "./SetSearch.vue?vue&type=style&index=0&id=720f446c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f446c",
  null
  
)

export default component.exports